/*
 * BB-CUSTOM: Mobile sticky add-to-cart behavior.
 * - Reveals the bar once the main product form scrolls out of view.
 * - Delegates the actual add-to-cart to Dawn's existing submit button so
 *   variant selection and AJAX cart handling are preserved.
 * - Mirrors the main submit button's available/sold-out/unavailable state.
 * - Keeps the displayed price in sync with the main price element.
 */
(function () {
  function init() {
    var bar = document.querySelector('[data-bb-sticky-atc]');
    if (!bar) return;

    var addBtn = bar.querySelector('[data-bb-sticky-add]');
    var stickyPrice = bar.querySelector('[data-bb-sticky-price]');

    function mainSubmit() {
      return document.querySelector('product-form .product-form__submit');
    }

    function isUnavailable(btn) {
      return Boolean(
        btn && (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true')
      );
    }

    function syncStickyAdd() {
      var btn = mainSubmit();
      if (!addBtn || !btn) return;

      addBtn.toggleAttribute('disabled', isUnavailable(btn));

      var label = btn.querySelector('span');
      if (label) {
        var text = label.textContent.trim();
        if (text) addBtn.textContent = text;
      }
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;

        var btn = mainSubmit();
        if (isUnavailable(btn)) {
          syncStickyAdd();
          return;
        }

        if (btn) {
          btn.click();
        } else {
          var form = document.querySelector('form[action$="/cart/add"]');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });

      syncStickyAdd();

      var formEl = document.querySelector('product-form') || mainSubmit();
      if (formEl && 'MutationObserver' in window) {
        new MutationObserver(syncStickyAdd).observe(formEl, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          subtree: true,
          childList: true,
          characterData: true,
        });
      }
    }

    // Reveal when the main buy area is no longer visible.
    var anchor = document.querySelector('product-form') || mainSubmit();
    if (anchor && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -120px 0px' }
      );
      observer.observe(anchor);
    } else {
      bar.classList.add('is-visible');
    }

    // Keep sticky price in sync with the main price element.
    var mainPrice = document.querySelector('[id^="price-"]');
    if (mainPrice && stickyPrice) {
      var sync = function () {
        var current =
          mainPrice.querySelector('.price-item--sale:not(.hidden)') ||
          mainPrice.querySelector('.price-item--regular');
        if (current) stickyPrice.textContent = current.textContent.trim();
      };
      sync();
      new MutationObserver(sync).observe(mainPrice, {
        subtree: true,
        childList: true,
        characterData: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
